import { MDBBtn, MDBChip, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formattedNumber, unFormatNumber } from '../../phonenumbers/AddRemoveNumbers';
import DeleteNumbers from '../../phonenumbers/DeleteNumbers';
import CampaignAddRemoveNumber from './CampaignAddRemoveNumber';
import PopupLoaderNew from '../../PopupLoaderNew';
import CampaignRejectedNumbers from '../../phonenumbers/CampaignRejectedNumbers';
import { Tooltip } from 'react-tooltip';
import ImportProgressWarning from '../../../../apiclients/ImportProgressWarning';
import { getImpExpStatusNew } from '../../../../apiclients/CommonUtils';
import ImpExpRedirectPopup from '../../../../apiclients/ImpExpRedirectPopup';
import ImportUser from '../../../../components/editviews/user/ImportUser';
import UIConstant from '../../../../apiclients/UIConstant';

function CampaignAssignTeleNumbers(props) {
    const { t, i18n } = useTranslation();
    const [AddNumbers, setAddNumbers] = useState(false);
    const toggleNumbers = () => setAddNumbers(!AddNumbers);
    const [isdeleteNumber, setIsDeleteNumbers] = useState(false);
    const dtogglePopup = () => setIsDeleteNumbers(!isdeleteNumber);
    const [rejectNumbers, setrejectNumbers] = useState(false);
    const toggleReject = () => setrejectNumbers(!rejectNumbers);
    const [savedNum, setsavedNum] = useState([]);
    const [showRejected, setshowRejected] = useState(false);
    const [showExportWarning, setShowExportWarning] = useState(false);
    const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
    const [warningMessage, setWarningMessage] = useState("");
    const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
    const [importUser, setimportUser] = useState(false);
    const importuserToggle = () => setimportUser(!importUser);
    const [firstRequest, setfirstRequest] = useState(false);
    const [Addbulk, setAddbulk] = useState(false);
    const toggleNumbebulk = () => setAddbulk(!Addbulk);
    const [bulkText, setBulkText] = useState("");
    const [bulkError, setBulkError] = useState("");
    const maxPhones = 49;
    const bulkTextRef = useRef("");

    const handelRejectNumbers = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setsavedNum(props.savedPhoneNumbers);
        setRejectCheckboxSelected(false);
        toggleReject();

    }

    useEffect(() => {
        if (props.savedPhoneNumbers && props.savedPhoneNumbers.length > 0) {
            setshowRejected(props.savedPhoneNumbers.some(phone => phone.status === 3 || phone.status === 4));

        }

    }, [props.savedPhoneNumbers]);

    const handleDeleteClose = () => {
        props.setSavedPhoneNumbers(props?.dbPhoneNumbers ?? props.savedPhoneNumbers);
        dtogglePopup();

    }
    const normalizePhoneToken = (token) => {
        return token.replace(/[^\d]/g, "");
    };

    // Pure parser
    const parseBulkNumbers = (text) => {

        if (!text || !text.trim()) {
            return { error: "Please enter at least one valid phone number", numbers: [] };
        }

        if (!/^[0-9+\-\(\)\s,\n\r]*$/.test(text)) {
            return { error: "Kindly enter valid phone number(s).", numbers: [] };
        }

        const tokens = text
            .split(/[,\n\r]+/)
            .map((t) => t.trim())
            .filter((t) => t.length > 0);

        const invalidDid = [];
        const didArray = [];

        tokens.forEach((token) => {

            if (/\s/.test(token) && !token.startsWith("+")) {
                invalidDid.push(token);
                return;
            }

            const digits = normalizePhoneToken(token);

            if (!/^[0-9]+$/.test(digits) || digits.length === 0) {
                invalidDid.push(token);
                return;
            }

            if (digits.length < 10 || digits.length > 11) {
                invalidDid.push(token);
                return;
            }

            if (digits.length === 11) {
                if (digits.charAt(0) !== "1") {
                    invalidDid.push(token);
                } else {
                    didArray.push(digits);
                }
            } else {
                didArray.push("1" + digits);
            }
        });

        if (invalidDid.length > 0) {
            return {
                error: `The following number(s) ${invalidDid.join(", ")} are invalid. Please remove them and resubmit your request with valid phone numbers.`,
                numbers: []
            };
        }

        const unique = [...new Set(didArray)];
        return { error: null, numbers: unique };
    };

    const handleBulkInput = (e) => {
        const text = e.target.value;
        setBulkText(text);
        bulkTextRef.current = text;
        setBulkError("");
    };

    const handleBulkAddClick = () => {
        const result = parseBulkNumbers(bulkTextRef.current);

        if (result.error) {
            setBulkError(result.error);
            return;
        }

        const availableSlots = maxPhones - (props.savedPhoneNumbers?.length || 0);
        if (result.numbers.length > availableSlots) {
            setBulkError("The maximum limit of 49 phone numbers have been exceeded.");
            return;
        }

        // Clear any previous API error before submitting
        setBulkError("");

        // Send clean array to parent — parent will close modal on success,
        // or surface the backend error (via bulkApiError prop) on failure.
        props.setUpdatePHNum(result.numbers);
        props.setUpdatebulkNumbersExecuted(true);
    };
    const handleDelete = async (number) => {
        const unformatNum = unFormatNumber(number);
        const updateAddPHNum = props.savedPhoneNumbers.filter(
            (num) => unformatNum !== num.nums
        );
        props.setSavedPhoneNumbers(updateAddPHNum);
        const result = await getImpExpStatusNew();
        if (result.status !== 0) {
            if (result.isOwnUser) {
                setShowImpExpRedirect(true);
                props.setSavedPhoneNumbers(props?.dbPhoneNumbers ?? props.savedPhoneNumbers);
            } else {
                const { userInfo } = result;
                if (userInfo?.isaccount) {
                    setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
                } else {
                    setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
                }
                exportwarningToggle();
                props.setSavedPhoneNumbers(props?.dbPhoneNumbers ?? props.savedPhoneNumbers);
            }
            return;
        }
        props.setUpdatePHNum([unformatNum]);
        dtogglePopup();
    };

    const addNumberRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [rejectCheckboxSelected, setRejectCheckboxSelected] = useState(false);

    function handleClick() {
        if (addNumberRef.current) {
            addNumberRef.current.click();
        }
    }

    const handleImportAndProceed = async () => {
        const result = await getImpExpStatusNew();
        if (result.status === 0) {
            toggleNumbers();
        } else if (result.isOwnUser) {
            setShowImpExpRedirect(true);
        } else {
            const { userInfo } = result;
            if (userInfo?.isaccount) {
                setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
            } else {
                setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
            }
            exportwarningToggle();
        }
    }

    const handleModalClose = () => {
        setAddNumbers(false);
        setAddbulk(false);      // ← reset bulk flag on every close
        setBulkText("");         // ← also clear stale textarea content
        setBulkError("");
    };

    // When parent signals bulk API success → close modal and clear fields
    useEffect(() => {
        if (props.bulkApiSuccess) {
            setAddNumbers(false);
            setAddbulk(false);
            setBulkText("");
            setBulkError("");
            props.setBulkApiSuccess(false); // reset so it can fire again next time
        }
    }, [props.bulkApiSuccess]);

    // When parent signals a bulk API error → keep modal open, surface the error
    useEffect(() => {
        if (props.bulkApiError) {
            setBulkError(props.bulkApiError);
        }
    }, [props.bulkApiError]);

    function changePhoneTypes() {
        setBulkError("");
        setBulkText("");
        toggleNumbebulk();
    }

    return (
        <>
            <div className="add-numbermain align-items-start">
                <div>
                    <div className="tel-numbers fw-500">Assigned Phone Numbers
                        <MDBIcon fas icon="info-circle" className='cursor-pointer ms-2 AssignPhoneNumbers ' />
                    </div>
                    <small className='text-muted fw-medium'>
                         After a campaign is successfully approved, phone numbers can be assigned only after 2 hours.
                    </small>
                </div>


                <MDBBtn
                    className={`ms-2 ${(!(props.status === "Pending" && !props.isCampaignEdit) || UIConstant.CampaignStatus.includes(props.status))
                        ? "disabled-form dispable-btn button-notallowed "
                        : ""
                        }`}
                    onClick={(e) => {
                        e.preventDefault();
                        if (!((props.status === "Pending" && !props.isCampaignEdit) || UIConstant.CampaignStatus.includes(props.status))) {
                            handleImportAndProceed();
                        }
                    }}
                >
                    <MDBIcon fas icon="plus" size="sm" /> {t("add_Numbers")}
                </MDBBtn>
            </div>
            <div className="mt-2">
                <div className="chips chips-placeholder d-flex align-items-start">
                    <div className='me-2'>
                        {showRejected && (
                            <div className='mt-2 mx-2' onClick={(e) => { handelRejectNumbers(e) }}>
                                <MDBIcon fas icon="exclamation-triangle" className='fs-5 cursor-pointer' color='danger' />

                            </div>
                        )}
                    </div>
                    <div>

                        {props.savedPhoneNumbers &&
                            props.savedPhoneNumbers.length > 0 &&
                            props.savedPhoneNumbers.map((phone) => (
                                <MDBChip
                                    className={`m-chip d-inline py-2 px-3 ${phone.status === 1 ? 'success' :
                                        phone.status === 2 ? 'warning' :
                                            (phone.status === 3 || phone.status === 4) ? 'danger' : phone.status === 5 ? 'bg-info bg-opacity-25' : ''
                                        }`}
                                    label="Example label"
                                    {...(((!props.status || (props.status !== "Pending" && (!(UIConstant.CampaignStatus.includes(props.status))))) && phone.status === 0 || (props.status === "Pending" && props.isCampaignEdit))
                                        ? {
                                            onDelete: () => handleDelete(phone.nums),
                                            closeIcon: true,
                                        }
                                        : {})}
                                    key={phone.nums}
                                    size="sm"
                                >
                                    {formattedNumber(phone.nums)}
                                </MDBChip>
                            ))}
                    </div>
                </div>
            </div>
            {/* </>} */}

            {AddNumbers && (
                <PopupLoaderNew
                    title={!Addbulk ? "Add Numbers" : "Bulk Phone Number Update"}
                    content={
                        <>
                            {!Addbulk ? (
                                <CampaignAddRemoveNumber
                                    selectedNum={props.savedPhoneNumbers}
                                    setUpdatePHNum={props.setUpdatePHNum}
                                    setUpdateNumbersExecuted={props.setUpdateNumbersExecuted}
                                    onClose={toggleNumbers}
                                    sourceNumber={props.sourceNumber}
                                    ref={addNumberRef}
                                    isSmsRegistration={true}
                                    setIsloading={setisLoading}
                                />
                            ) : (
                                <div className="bg-secondary p-3 rounded-3 bg-opacity-10 border border-color-secondary border-2 shadow-3-strong mt-3">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <label className="message-label fw-semibold mb-0">
                                            Paste Numbers for Bulk Selection
                                        </label>
                                    </div>
                                    <textarea
                                        className="form-control shadow-sm"
                                        rows={8}
                                        value={bulkText}
                                        onChange={handleBulkInput}
                                        placeholder={`Kindly enter SMS campaign numbers.`}
                                        style={{ resize: "vertical", fontSize: "0.875rem" }}
                                    />
                                    {bulkError && (
                                        <div className="mt-2 text-danger" style={{ fontSize: "0.875rem" }}>
                                            {bulkError}
                                        </div>
                                    )}

                                    <p className="phrecording text-muted  mb-0">
                                        <strong>Note: </strong>
                                        You can add a maximum of {49 - (props.savedPhoneNumbers?.length || 0)} phone numbers to a campaign. Please enter the phone numbers separated by a space, comma or on a new line.
                                    </p>
                                </div>
                            )}
                            <div className="mt-3">
                                <MDBBtn onClick={changePhoneTypes}>
                                    {!Addbulk ? (<><MDBIcon fas icon="upload" className="me-1" /> Bulk Phone Number Update</>) : (<><MDBIcon fas icon="th" className="me-1" /> Select Phone Numbers</>)}
                                </MDBBtn>
                            </div>
                        </>
                    }
                    onShow={setAddNumbers}
                    onClose={handleModalClose}
                    onSave={!Addbulk ? handleClick : handleBulkAddClick}
                    isloading={isLoading}
                    flag={1}
                />
            )}

            {isdeleteNumber && (
                <PopupLoaderNew
                    title={"Remove Telephone Number"}
                    content={
                        <DeleteNumbers
                            onClose={handleDeleteClose}
                            setDeleteNumberFlag={props.setDeleteNumberFlag}
                            ref={addNumberRef}
                            setIsloading={setisLoading}
                        />
                    }
                    onShow={setIsDeleteNumbers}
                    onClose={handleDeleteClose}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}
            {rejectNumbers && (
                <PopupLoaderNew
                    title={"Remove Telephone Number"}
                    content={
                        <CampaignRejectedNumbers
                            onClose={toggleReject}
                            savedNum={savedNum}
                            campaignid={props.campaignid}
                            brandid={props.brandid}
                            ref={addNumberRef}
                            setIsloading={setisLoading}
                            setSuccessMessage={props.setSuccessMessage}
                            setRerender={props.setRerender}
                            onCheckboxChange={setRejectCheckboxSelected}
                        />
                    }
                    onShow={setrejectNumbers}
                    onClose={toggleReject}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={10}
                    disableSave={!rejectCheckboxSelected}
                />
            )}

            {showExportWarning && (
                <ImportProgressWarning
                    warningToggle={exportwarningToggle}
                    setShowWarning={setShowExportWarning}
                    onOk={exportwarningToggle}
                    message={warningMessage}
                />
            )}

            {showImpExpRedirect && (
                <ImpExpRedirectPopup
                    onProceed={() => {
                        setShowImpExpRedirect(false);
                        setfirstRequest(true);
                        importuserToggle();
                    }}
                    onCancel={() => setShowImpExpRedirect(false)}
                />
            )}

            <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
                <MDBModalDialog size="fullscreen">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Import User Template</MDBModalTitle>
                        </MDBModalHeader>
                        <MDBModalBody className="pb-0">
                            <ImportUser
                                onClose={importuserToggle}
                                setIsloading={() => { }}
                                onShow={setimportUser}
                                show={importUser}
                                firstRequest={firstRequest}
                                setfirstRequest={setfirstRequest}
                            />
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <Tooltip anchorSelect=".AssignPhoneNumbers" place="top" className="exampleTooltipLight">
                <div style={{ padding: '10px', textAlign: "start" }}>
                    <div>No background - Request Successful</div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}><span style={{ width: '10px', height: '10px', backgroundColor: '#d1f5d3', marginRight: '5px' }}></span><span>Add request pending</span></div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}><span style={{ width: '10px', height: '10px', backgroundColor: '#fef4b7', marginRight: '5px' }}></span><span>Delete request pending</span></div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}><span style={{ width: '10px', height: '10px', backgroundColor: '#fdd6d4', marginRight: '5px' }}></span><span>Add/Delete request rejected</span></div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}><span style={{ width: '10px', height: '10px', backgroundColor: '#eed9ae', marginRight: '5px' }}></span><span>Number initiated — awaiting campaign assignment</span></div>
                </div>
            </Tooltip>
        </>
    )
}

export default CampaignAssignTeleNumbers;